
















import { Component, Vue, Watch } from 'vue-property-decorator';
import cCard from '@/components/default/Card.vue';
import ExternalInvoicesTable from '@/modules/externalInvoices/components/ExternalInvoicesTable.vue';
import PurchaseNavigation from '@/modules/shared/navigation/PurchaseNavigation.vue';

@Component({
  components: {
    cCard,
    ExternalInvoicesTable,
    PurchaseNavigation,
  },
})
export default class ExternalInvoicesOverviewPage extends Vue {

}
